import { atom } from 'recoil'
import { decrypt, encrypt } from 'utils/crypto-util'

//사용자상태
const userInfoState = atom({
  key: 'userInfoStateAtom',
  default: {
    userId: '',
    userName: '',
    coId: '',
    siteId: '',
    searchCustOrdrDdlClCd: '',
    phbtUseUser: false,
    phbtUseSiteList: [],
    phbtUseUserShpt: '',
  },
  effects_UNSTABLE: [
    ({ setSelf, onSet }) => {
      const key = 'userInfoState'
      const savedValue = localStorage.getItem(key)
      if (savedValue != null) {
        setSelf(JSON.parse(decrypt(savedValue)))
      }

      onSet((newValue) => {
        localStorage.setItem(key, encrypt(JSON.stringify(newValue)))
      })
    },
  ],
})

//샵목록
const shopListState = atom({
  key: 'shopListStateAtom',
  default: [],
  effects_UNSTABLE: [
    ({ setSelf, onSet }) => {
      const key = 'shopListState'
      const savedValue = localStorage.getItem(key)

      if (savedValue != null) {
        setSelf(JSON.parse(decrypt(savedValue)))
      }

      onSet((newValue) => {
        localStorage.setItem(key, encrypt(JSON.stringify(newValue)))
      })
    },
  ],
})

//사이트 목록
const siteListState = atom({
  key: 'siteListStateAtom',
  default: [],
  effects_UNSTABLE: [
    ({ setSelf, onSet }) => {
      const key = 'siteListState'
      const savedValue = localStorage.getItem(key)

      if (savedValue != null) {
        setSelf(JSON.parse(decrypt(savedValue)))
      }

      onSet((newValue) => {
        localStorage.setItem(key, encrypt(JSON.stringify(newValue)))
      })
    },
  ],
})

export { userInfoState, shopListState, siteListState }
